import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { appConfig, clientConfig } from "../../shared/constant/app.constant";
import { ThemeService } from "../../shared/theme/theme.service";

@Component({
  selector: "app-m-branding",
  templateUrl: "./branding.component.html",
  styleUrls: ["./branding.component.scss"],
})
export class MBrandingComponent implements OnInit,OnDestroy {
  subscription:any;
  @Input() brandInfo: BrandingInfo = {
    description: "Welcome to Brand return portal",
    logoSrc: "/logo.PNG",
  };

  constructor(private themeService: ThemeService) {}

  ngOnInit() {
    if (clientConfig.MERCHANTCONFIG_IN_DB && clientConfig.MERCHANTCONFIG_IN_DB.toLowerCase().trim() === "true") {
      this.subscription=this.themeService.logo$.subscribe(logo => {
          this.brandInfo.logoSrc = logo.data
      });
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


  handleImageError(event:any)
  {
    if (event.target.dataset.errorHandled) {
      return;
    }
      // Handle the error, set a fallback image
      if (clientConfig.MERCHANTNAME.toLowerCase().includes("sony"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/sony.png`;
      else if (clientConfig.MERCHANTNAME.toLowerCase().includes("schneider"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/schneider.png`;
      else if (clientConfig.MERCHANTNAME.toLowerCase().includes("starlink"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/starlink.png`;
      else if (clientConfig.TENANTNAME.toLowerCase().includes("kuehnenagel"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/kuehnenagel.png`;
      else
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/centiro.png`;

        event.target.dataset.errorHandled = 'true';
  }
}
